/* eslint-disable @cbhq/ts-no-enum */
export enum AnalyticEvent {
  // PAGE VIEWS
  GetStartedPageRendered = 'get_started_page_rendered',
  SecurityFrameLoaderPageRendered = 'security_frame_loader_page_rendered',
  ScanningPageRendered = 'scanning_page_rendered',
  WithdrawalDestinationPageRendered = 'withdrawal_destination_page_rendered',
  EnterWalletAddressesPageRendered = 'enter_wallet_addresses_page_rendered',
  ReviewPageRendered = 'review_page_rendered',
  BroadcastingPageRendered = 'broadcasting_page_rendered',
  StatusPageRendered = 'status_page_rendered',
  ErrorFallbackPageRendered = 'error_fallback_page_rendered',

  // BUTTON CLICKS
  GetStartedButtonClicked = 'get_started_button_clicked',
  WalletDestinationSelected = 'wallet_destination_selected',
  SubmitWalletAddressesClicked = 'submit_wallet_addresses_clicked',
  ReviewWithdrawalClicked = 'review_withdrawal_clicked',

  // WITHDRAWAL SUCCESS EVENTS
  WithdrawalSigningSuccess = 'withdrawal_signing_success',
  WithdrawalBroadcastSuccess = 'withdrawal_broadcast_success',

  // ERRORS
  IndexedDbQueryError = 'indexed_db_query_error',
  ConstructTransactionError = 'construct_transaction_error',
  SignTransactionError = 'sign_transaction_error',
  GetAddressesError = 'get_addresses_error',
  GetEthBalanceError = 'get_eth_balance_error',
  GetUtxosError = 'get_utxos_error',
  FetchXPubError = 'fetch_xpub_error',
  XPubScanningError = 'xpub_scanning_error',
  WithdrawalBroadcastFailure = 'withdrawal_broadcast_failure',
}
